import { IIconProps } from './icon';

export const IconHelp = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="#515252"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconHelp${cy}`}
    >
      <path d="M7.00001 0.833252C3.32001 0.833252 0.333344 3.81992 0.333344 7.49992C0.333344 11.1799 3.32001 14.1666 7.00001 14.1666C10.68 14.1666 13.6667 11.1799 13.6667 7.49992C13.6667 3.81992 10.68 0.833252 7.00001 0.833252ZM7.66668 12.1666H6.33334V10.8333H7.66668V12.1666ZM9.04668 6.99992L8.44668 7.61325C7.96668 8.09992 7.66668 8.49992 7.66668 9.49992H6.33334V9.16659C6.33334 8.43325 6.63334 7.76659 7.11334 7.27992L7.94001 6.43992C8.18668 6.19992 8.33334 5.86659 8.33334 5.49992C8.33334 4.76659 7.73334 4.16659 7.00001 4.16659C6.26668 4.16659 5.66668 4.76659 5.66668 5.49992H4.33334C4.33334 4.02659 5.52668 2.83325 7.00001 2.83325C8.47334 2.83325 9.66668 4.02659 9.66668 5.49992C9.66668 6.08659 9.42668 6.61992 9.04668 6.99992Z" />
    </svg>
  );
};
